module.exports = __webpack_public_path__ + "img/nebraska-branchpattern.2181c68f.jpeg";